require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-region-oriente-medio-y-africa-del-norte.json") })
        }
      }, "path---es-mx-region-oriente-medio-y-africa-del-norte");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-region-oriente-medio-y-africa-del-norte!./.cache/json/es-mx-region-oriente-medio-y-africa-del-norte.json
// module id = 906
// module chunks = 231608221292675